package diana.soleil.design.iraniancanadienbazzar.feature.dashboard

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.input.KeyboardType
import androidx.lifecycle.ViewModel
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewModelScope
import diana.soleil.design.iraniancanadienbazzar.core.common.DataResult
import diana.soleil.design.iraniancanadienbazzar.core.data.BusinessRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.CategoryRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.ImagePickController
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SettingsToggleRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.model.Address
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.model.BusinessStatus
import diana.soleil.design.iraniancanadienbazzar.core.model.Category
import diana.soleil.design.iraniancanadienbazzar.core.model.ListingChangeRequest
import diana.soleil.design.iraniancanadienbazzar.core.model.ListingDetailsEdit
import diana.soleil.design.iraniancanadienbazzar.core.model.LocalizedText
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_retry
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_add_photo
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_address_line_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_category_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_change_cover
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_change_logo
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_city_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_day_fri
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_day_mon
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_day_sat
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_day_sun
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_day_thu
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_day_tue
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_day_wed
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_description_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_email_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_error
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_hours_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_identity_hint
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_lang_en
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_lang_fa
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_lang_fr
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_language_hint
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_name_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_offers_chat
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_offers_ordering
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_pending_address
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_pending_category
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_pending_name
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_pending_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_phone_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_photo_failed
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_postal_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_province_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_remove_photo_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_request_button
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_request_failed
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_request_sent
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_save
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_save_failed
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_saved
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_section_about
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_section_contact
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_section_hours
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_section_identity
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_section_languages
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_section_photos
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_section_price
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_service_title_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.edit_website_label
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

/** Transient outcome of one editor action, shown under its button. */
enum class EditOutcome { Idle, Busy, Done, Failed }

data class EditListingUiState(
    val loading: Boolean = true,
    val error: Boolean = false,
    val business: Business? = null,
    val save: EditOutcome = EditOutcome.Idle,
    val photo: EditOutcome = EditOutcome.Idle,
    val request: EditOutcome = EditOutcome.Idle,
)

/**
 * Owner editor for one listing (owner report 2026-09-14: a new owner "was not able to edit most items").
 * Details save straight to the listing; name / category / address go to an admin as a change request.
 */
class EditListingViewModel(
    private val businessId: String,
    private val businessRepository: BusinessRepository,
    categoryRepository: CategoryRepository,
    private val imagePicker: ImagePickController,
) : ViewModel() {
    private val _state = MutableStateFlow(EditListingUiState())
    val state: StateFlow<EditListingUiState> = _state.asStateFlow()

    val categories: StateFlow<List<Category>> = categoryRepository.observeCategories()
        .map { (it as? DataResult.Success)?.data.orEmpty().sortedBy { category -> category.order } }
        .stateIn(viewModelScope, SharingStarted.WhileSubscribed(5_000), emptyList())

    val pendingChanges: StateFlow<List<ListingChangeRequest>> =
        businessRepository.observePendingListingChanges(businessId)
            .map { (it as? DataResult.Success)?.data.orEmpty() }
            .stateIn(viewModelScope, SharingStarted.WhileSubscribed(5_000), emptyList())

    init {
        load()
    }

    fun load() {
        viewModelScope.launch { reload(showSpinner = true) }
    }

    private suspend fun reload(showSpinner: Boolean) {
        if (showSpinner) _state.value = _state.value.copy(loading = true, error = false)
        _state.value = when (val result = businessRepository.getBusiness(businessId)) {
            is DataResult.Success -> _state.value.copy(loading = false, error = false, business = result.data)
            is DataResult.Failure -> _state.value.copy(loading = false, error = _state.value.business == null)
        }
    }

    fun saveDetails(edit: ListingDetailsEdit) {
        viewModelScope.launch {
            _state.value = _state.value.copy(save = EditOutcome.Busy)
            val ok = businessRepository.updateListingDetails(businessId, edit) is DataResult.Success
            reload(showSpinner = false)
            _state.value = _state.value.copy(save = if (ok) EditOutcome.Done else EditOutcome.Failed)
        }
    }

    fun changeCover() = pickAndUpload { image -> businessRepository.uploadBusinessMedia(businessId, image, null, emptyList()) }

    fun changeLogo() = pickAndUpload { image -> businessRepository.uploadBusinessMedia(businessId, null, image, emptyList()) }

    fun addPhoto() = pickAndUpload { image -> businessRepository.uploadBusinessMedia(businessId, null, null, listOf(image)) }

    fun removePhoto(url: String) {
        viewModelScope.launch {
            _state.value = _state.value.copy(photo = EditOutcome.Busy)
            val ok = businessRepository.removeBusinessPhoto(businessId, url) is DataResult.Success
            reload(showSpinner = false)
            _state.value = _state.value.copy(photo = if (ok) EditOutcome.Idle else EditOutcome.Failed)
        }
    }

    private fun pickAndUpload(upload: suspend (diana.soleil.design.iraniancanadienbazzar.core.model.PickedImage) -> DataResult<Unit>) {
        viewModelScope.launch {
            val image = imagePicker.pick() ?: return@launch
            _state.value = _state.value.copy(photo = EditOutcome.Busy)
            val ok = upload(image) is DataResult.Success
            reload(showSpinner = false)
            _state.value = _state.value.copy(photo = if (ok) EditOutcome.Idle else EditOutcome.Failed)
        }
    }

    fun requestChange(name: String, categoryId: String, address: Address) {
        val business = _state.value.business ?: return
        viewModelScope.launch {
            _state.value = _state.value.copy(request = EditOutcome.Busy)
            val ok = businessRepository.requestListingChange(business, name, categoryId, address) is DataResult.Success
            _state.value = _state.value.copy(request = if (ok) EditOutcome.Done else EditOutcome.Failed)
        }
    }
}

private val DAY_KEYS = listOf("mon", "tue", "wed", "thu", "fri", "sat", "sun")

private fun dayLabel(key: String): StringResource = when (key) {
    "mon" -> Res.string.edit_day_mon
    "tue" -> Res.string.edit_day_tue
    "wed" -> Res.string.edit_day_wed
    "thu" -> Res.string.edit_day_thu
    "fri" -> Res.string.edit_day_fri
    "sat" -> Res.string.edit_day_sat
    else -> Res.string.edit_day_sun
}

/** The stored text for exactly [code] — no fallback, so editing Farsi never saves the English copy as Farsi. */
private fun LocalizedText?.exact(code: String): String = when (code) {
    "fr" -> this?.fr
    "fa" -> this?.fa
    else -> this?.en
}.orEmpty()

private fun LocalizedText?.with(code: String, value: String): LocalizedText = LocalizedText(
    en = if (code == "en") value else this?.en,
    fr = if (code == "fr") value else this?.fr,
    fa = if (code == "fa") value else this?.fa,
)

@Composable
fun EditListingRoute(
    businessId: String,
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: EditListingViewModel = koinViewModel(parameters = { parametersOf(businessId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val categories by viewModel.categories.collectAsStateWithLifecycle()
    val pending by viewModel.pendingChanges.collectAsStateWithLifecycle()

    Column(
        modifier = modifier
            .background(AppTheme.colors.background)
            .appContentWidth(AppTheme.sizes.readingMaxWidth)
            .fillMaxHeight()
            .statusBarsPadding()
            .navigationBarsPadding(),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppTheme.spacing.lg),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.dash_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onSurface,
            )
            Text(
                text = stringResource(Res.string.edit_title),
                style = AppTheme.typography.headlineLg,
                color = AppTheme.colors.onSurface,
                modifier = Modifier.weight(1f),
            )
        }
        val business = state.business
        when {
            state.loading && business == null -> LoadingState()
            state.error || business == null -> ErrorState(
                message = stringResource(Res.string.edit_error),
                onRetry = viewModel::load,
                retryLabel = stringResource(Res.string.dash_retry),
            )
            else -> EditListingForm(
                business = business,
                categories = categories,
                pending = pending,
                state = state,
                onSaveDetails = viewModel::saveDetails,
                onChangeCover = viewModel::changeCover,
                onChangeLogo = viewModel::changeLogo,
                onAddPhoto = viewModel::addPhoto,
                onRemovePhoto = viewModel::removePhoto,
                onRequestChange = viewModel::requestChange,
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun EditListingForm(
    business: Business,
    categories: List<Category>,
    pending: List<ListingChangeRequest>,
    state: EditListingUiState,
    onSaveDetails: (ListingDetailsEdit) -> Unit,
    onChangeCover: () -> Unit,
    onChangeLogo: () -> Unit,
    onAddPhoto: () -> Unit,
    onRemovePhoto: (String) -> Unit,
    onRequestChange: (name: String, categoryId: String, address: Address) -> Unit,
) {
    val lang = AppTheme.language
    val code = lang.code
    // Keyed on the listing id + language: a save re-reads the listing, and re-seeding the fields from it
    // would wipe what the owner is still typing. Switching language re-seeds on purpose.
    var serviceTitle by remember(business.id, code) { mutableStateOf(business.serviceTitle.exact(code)) }
    var description by remember(business.id, code) { mutableStateOf(business.description.exact(code)) }
    var phone by remember(business.id) { mutableStateOf(business.phone.orEmpty()) }
    var email by remember(business.id) { mutableStateOf(business.email.orEmpty()) }
    var website by remember(business.id) { mutableStateOf(business.website.orEmpty()) }
    var hours by remember(business.id) { mutableStateOf(DAY_KEYS.associateWith { business.hours[it].orEmpty() }) }
    var languages by remember(business.id) { mutableStateOf(business.languagesSpoken) }
    var priceLevel by remember(business.id) { mutableStateOf(business.priceLevel) }
    var offersChat by remember(business.id) { mutableStateOf(business.offersChat) }
    var offersOrdering by remember(business.id) { mutableStateOf(business.offersOrdering) }

    var name by remember(business.id) { mutableStateOf(business.name) }
    var categoryId by remember(business.id) { mutableStateOf(business.categoryId) }
    var addressLine by remember(business.id) { mutableStateOf(business.address.line) }
    var city by remember(business.id) { mutableStateOf(business.address.city) }
    var province by remember(business.id) { mutableStateOf(business.address.province) }
    var postalCode by remember(business.id) { mutableStateOf(business.address.postalCode.orEmpty()) }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(horizontal = AppTheme.spacing.lg)
            .padding(bottom = AppTheme.spacing.xl),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        // ── Photos: saved the moment they're picked.
        SectionHeader(title = stringResource(Res.string.edit_section_photos))
        BusinessCover(
            imageUrl = business.coverUrl,
            modifier = Modifier.fillMaxWidth().aspectRatio(16f / 9f).clip(AppTheme.shapes.card),
        )
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            AppButton(
                text = stringResource(Res.string.edit_change_cover),
                onClick = onChangeCover,
                variant = AppButtonVariant.Secondary,
                leadingIcon = "image",
                enabled = state.photo != EditOutcome.Busy,
                modifier = Modifier.weight(1f),
            )
            AppButton(
                text = stringResource(Res.string.edit_change_logo),
                onClick = onChangeLogo,
                variant = AppButtonVariant.Secondary,
                // Must be an icon name already used in code: the icon font is subset to those
                // (scripts/subset-icon-fonts.sh) and an unknown name renders as its raw text.
                leadingIcon = "storefront",
                enabled = state.photo != EditOutcome.Busy,
                modifier = Modifier.weight(1f),
            )
        }
        if (business.photos.isNotEmpty()) {
            LazyRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                items(business.photos, key = { it }) { url ->
                    Box(modifier = Modifier.width(AppTheme.sizes.featuredCardWidth / 2)) {
                        BusinessCover(
                            imageUrl = url,
                            modifier = Modifier.fillMaxWidth().aspectRatio(1f).clip(AppTheme.shapes.card),
                        )
                        AppIconButton(
                            iconName = "close",
                            contentDescription = stringResource(Res.string.edit_remove_photo_a11y),
                            onClick = { onRemovePhoto(url) },
                            enabled = state.photo != EditOutcome.Busy,
                            tint = AppTheme.colors.onSurface,
                            modifier = Modifier
                                .align(Alignment.TopEnd)
                                .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.pill),
                        )
                    }
                }
            }
        }
        AppButton(
            text = stringResource(Res.string.edit_add_photo),
            onClick = onAddPhoto,
            variant = AppButtonVariant.Secondary,
            leadingIcon = "add_photo_alternate",
            loading = state.photo == EditOutcome.Busy,
            enabled = state.photo != EditOutcome.Busy,
            modifier = Modifier.fillMaxWidth(),
        )
        if (state.photo == EditOutcome.Failed) ErrorLine(stringResource(Res.string.edit_photo_failed))

        // ── About + contact + hours + languages + price + toggles: one Save.
        SectionHeader(title = stringResource(Res.string.edit_section_about))
        HintLine(stringResource(Res.string.edit_language_hint))
        AppTextField(
            value = serviceTitle,
            onValueChange = { if (it.length <= 120) serviceTitle = it },
            label = stringResource(Res.string.edit_service_title_label),
        )
        AppTextField(
            value = description,
            onValueChange = { if (it.length <= 2000) description = it },
            label = stringResource(Res.string.edit_description_label),
            singleLine = false,
        )
        SectionHeader(title = stringResource(Res.string.edit_section_contact))
        AppTextField(
            value = phone,
            onValueChange = { if (it.length <= 30) phone = it },
            label = stringResource(Res.string.edit_phone_label),
            keyboardType = KeyboardType.Phone,
        )
        AppTextField(
            value = email,
            onValueChange = { if (it.length <= 120) email = it },
            label = stringResource(Res.string.edit_email_label),
            keyboardType = KeyboardType.Email,
        )
        AppTextField(
            value = website,
            onValueChange = { if (it.length <= 200) website = it },
            label = stringResource(Res.string.edit_website_label),
            keyboardType = KeyboardType.Uri,
        )
        SectionHeader(title = stringResource(Res.string.edit_section_hours))
        DAY_KEYS.forEach { day ->
            AppTextField(
                value = hours[day].orEmpty(),
                onValueChange = { value -> if (value.length <= 40) hours = hours + (day to value) },
                label = stringResource(dayLabel(day)),
                placeholder = stringResource(Res.string.edit_hours_placeholder),
            )
        }
        SectionHeader(title = stringResource(Res.string.edit_section_languages))
        FlowRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            listOf("fa" to Res.string.edit_lang_fa, "en" to Res.string.edit_lang_en, "fr" to Res.string.edit_lang_fr)
                .forEach { (langCode, label) ->
                    AppChip(
                        label = stringResource(label),
                        selected = langCode in languages,
                        onClick = { languages = if (langCode in languages) languages - langCode else languages + langCode },
                    )
                }
        }
        SectionHeader(title = stringResource(Res.string.edit_section_price))
        FlowRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            (1..4).forEach { level ->
                AppChip(
                    label = "$".repeat(level),
                    selected = priceLevel == level,
                    onClick = { priceLevel = if (priceLevel == level) null else level },
                )
            }
        }
        SettingsToggleRow(
            iconName = "chat",
            title = stringResource(Res.string.edit_offers_chat),
            checked = offersChat,
            onCheckedChange = { offersChat = it },
        )
        SettingsToggleRow(
            iconName = "shopping_bag",
            title = stringResource(Res.string.edit_offers_ordering),
            checked = offersOrdering,
            onCheckedChange = { offersOrdering = it },
        )
        AppButton(
            text = stringResource(Res.string.edit_save),
            onClick = {
                onSaveDetails(
                    ListingDetailsEdit(
                        serviceTitle = business.serviceTitle.with(code, serviceTitle),
                        description = business.description.with(code, description),
                        phone = phone,
                        email = email,
                        website = website,
                        hours = hours,
                        languagesSpoken = languages,
                        priceLevel = priceLevel,
                        offersChat = offersChat,
                        offersOrdering = offersOrdering,
                    ),
                )
            },
            loading = state.save == EditOutcome.Busy,
            enabled = state.save != EditOutcome.Busy,
            modifier = Modifier.fillMaxWidth(),
        )
        when (state.save) {
            EditOutcome.Done -> HintLine(stringResource(Res.string.edit_saved))
            EditOutcome.Failed -> ErrorLine(stringResource(Res.string.edit_save_failed))
            else -> Unit
        }

        // ── Identity: name, category, address — admin-approved.
        SectionHeader(title = stringResource(Res.string.edit_section_identity))
        HintLine(stringResource(Res.string.edit_identity_hint))
        if (pending.isNotEmpty()) {
            AppCard(modifier = Modifier.fillMaxWidth()) {
                Column(
                    modifier = Modifier.padding(AppTheme.spacing.lg),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                ) {
                    Text(
                        text = stringResource(Res.string.edit_pending_title),
                        style = AppTheme.typography.labelMd,
                        color = AppTheme.colors.onSurface,
                    )
                    pending.forEach { request ->
                        request.proposedName?.let { HintLine(stringResource(Res.string.edit_pending_name, it)) }
                        request.proposedCategoryId?.let { id ->
                            val label = categories.firstOrNull { it.id == id }?.label(lang) ?: id
                            HintLine(stringResource(Res.string.edit_pending_category, label))
                        }
                        request.proposedAddress?.let { HintLine(stringResource(Res.string.edit_pending_address, it.formatted())) }
                    }
                }
            }
        }
        AppTextField(
            value = name,
            onValueChange = { if (it.length <= 120) name = it },
            label = stringResource(Res.string.edit_name_label),
        )
        Text(
            text = stringResource(Res.string.edit_category_label),
            style = AppTheme.typography.labelMd,
            color = AppTheme.colors.onSurfaceVariant,
        )
        FlowRow(
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            categories.forEach { category ->
                AppChip(
                    label = category.label(lang),
                    selected = categoryId == category.id,
                    onClick = { categoryId = category.id },
                )
            }
        }
        AppTextField(
            value = addressLine,
            onValueChange = { if (it.length <= 200) addressLine = it },
            label = stringResource(Res.string.edit_address_line_label),
        )
        AppTextField(
            value = city,
            onValueChange = { if (it.length <= 80) city = it },
            label = stringResource(Res.string.edit_city_label),
        )
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            AppTextField(
                value = province,
                onValueChange = { if (it.length <= 40) province = it },
                label = stringResource(Res.string.edit_province_label),
                modifier = Modifier.weight(1f),
            )
            AppTextField(
                value = postalCode,
                onValueChange = { if (it.length <= 12) postalCode = it },
                label = stringResource(Res.string.edit_postal_label),
                modifier = Modifier.weight(1f),
            )
        }
        val newAddress = business.address.copy(
            line = addressLine.trim(),
            city = city.trim(),
            province = province.trim(),
            postalCode = postalCode.trim().ifBlank { null },
        )
        val identityChanged = name.trim() != business.name ||
            categoryId != business.categoryId ||
            newAddress != business.address
        AppButton(
            text = stringResource(Res.string.edit_request_button),
            onClick = { onRequestChange(name, categoryId, newAddress) },
            variant = if (business.status == BusinessStatus.Approved) AppButtonVariant.Secondary else AppButtonVariant.Primary,
            loading = state.request == EditOutcome.Busy,
            enabled = identityChanged && name.isNotBlank() && addressLine.isNotBlank() && city.isNotBlank() &&
                state.request != EditOutcome.Busy,
            modifier = Modifier.fillMaxWidth(),
        )
        when (state.request) {
            EditOutcome.Done -> HintLine(stringResource(Res.string.edit_request_sent))
            EditOutcome.Failed -> ErrorLine(stringResource(Res.string.edit_request_failed))
            else -> Unit
        }
    }
}

private fun Category.label(language: diana.soleil.design.iraniancanadienbazzar.core.model.Language): String =
    nameLocalized?.resolve(language)?.takeIf { it.isNotBlank() } ?: name

@Composable
private fun HintLine(text: String) {
    Text(text = text, style = AppTheme.typography.bodySm, color = AppTheme.colors.onSurfaceVariant)
}

@Composable
private fun ErrorLine(text: String) {
    Text(text = text, style = AppTheme.typography.labelSm, color = AppTheme.colors.error)
}
